import { useExplorer } from "@/context/ExplorerContext";
import { ImageSlot, hasImage } from "@/components/lurio/ImageSlot";
import { Eyebrow, Hand, Section, Tape, Fr } from "@/components/lurio/Primitives";
import { Reveal } from "@/components/lurio/Motion";

export default function Promise() {
  const { t } = useExplorer();
  const [before, after] = t.promise.body.split("Ma Grande Aventure Scolaire");
  return (
    <Section id="promesse">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow className="mb-5">{t.promise.eyebrow}</Eyebrow>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-4xl font-bold leading-[1.3] sm:leading-[1.3] lg:leading-[1.3] text-ink sm:text-5xl lg:text-6xl">
              {t.promise.statement.map((l, i) => (
                <span key={i} className={`block ${i === 2 ? "text-blue" : ""}`}>
                  {i === 1 ? <span className="doodle-underline">{l}</span> : l}
                </span>
              ))}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-xl text-[1.08rem] leading-[1.85] text-ink-soft sm:text-lg">
              {before}
              <Fr className="font-semibold text-ink">Ma Grande Aventure Scolaire</Fr>
              {after}
            </p>
          </Reveal>
          {hasImage("promise_photo") && (
            <Reveal delay={0.15} className="mt-10 hidden max-w-xs lg:block">
              <ImageSlot id="promise_photo" className="rotate-[1.5deg]" />
              <Hand className="mt-3 text-xl" tone="text-pencil" rotate={2}>
                {t.promise.margin}
              </Hand>
            </Reveal>
          )}
        </div>
        <div className="lg:col-span-5 lg:pt-16">
          <Reveal delay={0.1} className="paper-card grain relative rotate-[-1deg] p-7 sm:p-9">
            <Tape className="-top-3 start-8 rotate-[4deg]" />
            <ol className="space-y-8">
              {t.promise.benefits.map((b) => (
                <li key={b.n} data-testid={`benefit-${b.n}`} className="grid grid-cols-[auto_1fr] gap-4">
                  <span className="font-latin text-4xl font-light leading-none text-gold" dir="ltr">{b.n}</span>
                  <div>
                    <h3 className="font-serif text-2xl font-bold text-blue">{b.title}</h3>
                    <p className="mt-1.5 text-[1rem] leading-[1.8] text-ink-soft">{b.text}</p>
                  </div>
                </li>
              ))}
            </ol>
          </Reveal>
          {hasImage("promise_photo") && (
            <Reveal delay={0.2} className="mt-8 lg:hidden">
              <ImageSlot id="promise_photo" className="rotate-[1deg]" />
            </Reveal>
          )}
        </div>
      </div>
    </Section>
  );
}
